import { render } from "./definition.vue?vue&type=template&id=05bc3c91"
import script from "./definition.vue?vue&type=script&lang=js"
export * from "./definition.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__